
import { transform, isArray, camelCase, isObject } from 'lodash'

function toCamelCase(obj) {
  return transform(obj, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : camelCase(key)
    acc[camelKey] = isObject(value) ? toCamelCase(value) : value
  })
}

function preprocessRequestFormValues(pendingFormData) {
  let formValues = {}

  formValues.student = toCamelCase(pendingFormData.student)
  formValues.schoolYear = pendingFormData.student.metastudent.school_year
  formValues.district = pendingFormData.student_info.district
  formValues.infoRequestingDistrict = pendingFormData.schedule_request.info_requesting_district
  formValues.infoResidentDistrict = pendingFormData.schedule_request.info_resident_district

  formValues.student.marssCode = null
  formValues.student.studentId = pendingFormData.student.public_id
  formValues.student.grade = pendingFormData.schedule_request.grade
  formValues.student.language = pendingFormData.student.language.toLowerCase()
  formValues.student.program = pendingFormData.schedule_request.program.id
  formValues.student.marssCode = pendingFormData.schedule_request.marssCode

  formValues.contacts = toCamelCase(pendingFormData.student_contacts)
  formValues.address = pendingFormData.schedule_request.address
  formValues.scheduleRequest = toCamelCase(pendingFormData.schedule_request)
  formValues.scheduleRequest.notes = pendingFormData.schedule_request.notes
    ? JSON.parse(pendingFormData.schedule_request.notes)
    : {}

  convertZipCodesToSnakeCase(formValues.scheduleRequest)

  console.log(formValues)
  return formValues
}

function convertZipCodesToSnakeCase(currObj) {
  for (const prop in currObj) {
    if (prop === 'zipCode') {
      let tempZipCode = currObj.zipCode
      delete currObj.zipCode
      currObj.zip_code = tempZipCode
    }
    else {
      if (isArray(currObj[prop])) {
        for (const item of currObj[prop]) {
          convertZipCodesToSnakeCase(item)
        }
      }
      else if (isObject(currObj[prop])) {
        convertZipCodesToSnakeCase(currObj[prop])
      }
    }
  }
}

function remapStudentDetailToFormValues(studentDetail) {
  console.log(studentDetail)
  let remappedObj = {}

  remappedObj.requestedStartDate = studentDetail.startDate
  remappedObj.requestedEndDate = studentDetail.endDate
  remappedObj.building = studentDetail.building
  remappedObj.address = studentDetail.address
  remappedObj.pickupAddress = studentDetail.pickupAddress
  remappedObj.dropoffAddress = studentDetail.dropoffAddress
  remappedObj.notes = studentDetail.notes
  remappedObj.scheduleRequestWeekdays = undefined
  remappedObj.grade = studentDetail.grade
  remappedObj.infoAide = studentDetail.infoAide
  remappedObj.infoWheelchair = studentDetail.infoWheelchair
  remappedObj.infoSolo = studentDetail.infoSolo
  remappedObj.infoEnclosedVehicle = studentDetail.infoEnclosedVehicle
  remappedObj.infoBoosterSeat = studentDetail.infoBoosterSeat
  remappedObj.infoSafetyVest = studentDetail.infoSafetyVest
  remappedObj.infoSafetyBeltLockingCover = studentDetail.infoSafetyBeltLockingCover
  remappedObj.infoCarSeat = studentDetail.infoCarSeat
  remappedObj.infoResidentDistrict = studentDetail.infoResidentDistrict
  remappedObj.infoRequestingDistrict = studentDetail.infoRequestingDistrict
  remappedObj.studentRelease = studentDetail.studentRelease
  remappedObj.scheduleRequest = toCamelCase(studentDetail.scheduleRequest)
  remappedObj.marssCode = studentDetail.marssCode
  remappedObj.program = studentDetail.program
  remappedObj.medicalNotes = studentDetail.medicalNotes

  return remappedObj
}


export default {
  preprocessRequestFormValues,
  remapStudentDetailToFormValues,
}
